module.exports = __webpack_public_path__ + "img/sec-227-ktb.25aa8777.svg";